import React from "react";
import "./Home.css";

function Toilet() {
  return (
    <div className="home-section-container">
      <div className="home-content-split">
        <div className="home-text-content">
          <div className="title-text-cont">
            <h1>TOILET</h1>
            <p className="home-subtitle">
              <img
                className="brandImg"
                style={{ backgroundColor: "white" }}
                src="/toiletBrand.avif"
              />
              <br />
              Evo M • Portable Composting Toilet for Adventurers
            </p>
          </div>
        </div>

        <div className="home-image-content">
          <iframe src="https://drive.google.com/file/d/1YdtKUqrVy6GXS81KPGgMQYhBMt6DiXQg/preview"></iframe>
        </div>
      </div>

      <div className="outdoorsy-container" style={{ textAlign: "left" }}>
        <p className="tealText">
          Number One: The urine canister holds 1.3 US gal and fits 9–11 #1s.
        </p>
        <p className="tealText">
          Number Two: The solids container holds 2.1 US gal and fits 6–12 #2s.
        </p>
        <p className="tealText">
            Please be careful not to overfill either container!! A sanitation fee will be added for any mess upon drop-off
        </p>
        <p className="tealText">
          Toilet paper, solids liners (1-2 for shorter trips, will supply more for longer rentals), and composting substrate will be provided
        </p>

        <p className="tealText">
          The solids container will have a layer of substrate on the bottom. After each poop, sprinkle enough substrate to cover the poop. A dash of water here and there helps with composting, but isn't necessary at all
        </p>
        <p className="tealText">
          To empty the solids container, just remove the bag/lining, tie it off, and dispose anywhere that accepts compostable waste. We definitely encourage guests to empty containers before dropping off van, but it's ok if not
        </p>
      </div>

      <div className="movCont">
        <img src="/toilet.jpg" className="home-image" />
      </div>
    </div>
  );
}

export default Toilet;
